import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export async function requestTranslationDraft({ token, resourceType, source, translations = {} }) {
  const { data } = await axios.post(
    `${API}/admin/translations/draft`,
    { resource_type: resourceType, source, translations },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return data;
}
